import { render, staticRenderFns } from "./AddTrainingToUserModal.vue?vue&type=template&id=6c901503"
import script from "./AddTrainingToUserModal.vue?vue&type=script&lang=js"
export * from "./AddTrainingToUserModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports